import type { ConversationDataPayload } from '@claudafinil/shared/contract';
import { truncateText } from '../../utils/text';
import type { ConversationNode } from './types';

const PREVIEW_LENGTH = 40;
const TOOLTIP_LENGTH = 100;

export function buildNodeMap(
  messages: ConversationDataPayload['messages'],
): Map<string, ConversationNode> {
  const nodeMap = new Map<string, ConversationNode>();

  for (const message of messages) {
    nodeMap.set(message.uuid, {
      uuid: message.uuid,
      parentUuid: message.parentUuid,
      sender: message.sender,
      preview: truncateText(message.text, PREVIEW_LENGTH),
      fullText: message.text,
      tooltipPreview: truncateText(message.text, TOOLTIP_LENGTH),
      children: [],
      isOnActivePath: false,
    });
  }

  return nodeMap;
}

export function populateChildren(
  nodeMap: Map<string, ConversationNode>,
): string | null {
  let rootNodeId: string | null = null;

  for (const node of nodeMap.values()) {
    if (node.parentUuid === null) {
      rootNodeId = node.uuid;
      continue;
    }

    const parentNode = nodeMap.get(node.parentUuid);
    if (parentNode) {
      parentNode.children.push(node.uuid);
    }
  }

  return rootNodeId;
}

export function markActivePath(
  nodeMap: Map<string, ConversationNode>,
  currentLeafId: string,
): void {
  let currentId: string | null = currentLeafId;

  while (currentId !== null) {
    const node = nodeMap.get(currentId);
    if (!node) {
      break;
    }

    node.isOnActivePath = true;
    currentId = node.parentUuid;
  }
}

export function clearActivePath(
  nodeMap: Map<string, ConversationNode>,
): void {
  for (const node of nodeMap.values()) {
    node.isOnActivePath = false;
  }
}
